import { BrandEnum } from '../_common/enum/brand.enum';

/**
 * Exact origins (production / marketing sites) → brand.
 * Hostname heuristics in resolveBrandFromUrl run first for app URLs (e.g. *dcs*, *arcs*, *mistycroft*).
 */
export const originToBrand: Record<string, BrandEnum> = {
    'https://daffodilcare.ie': BrandEnum.DaffodilCare,
    'https://arcs.ie': BrandEnum.Arcs,
};

function hostnameBrand(hostname: string): BrandEnum | undefined {
    const h = hostname.toLowerCase();
    const segments = h.split('.');

    if (h.includes('mistycroft') || h.includes('misty-croft') || h.includes('mistrycroft')) {
        return BrandEnum.MistyCroft;
    }

    if (segments.some((part) => part === 'arcs' || part === 'acrs')) {
        return BrandEnum.Arcs;
    }

    if (h.includes('dcs') || h.includes('daffodilcare') || h.includes('daffodil')) {
        return BrandEnum.DaffodilCare;
    }

    return undefined;
}

export function resolveBrandFromUrl(rawUrl: string): BrandEnum | undefined {
    if (!rawUrl) return undefined;

    let origin: string;
    let hostname: string;

    try {
        const u = new URL(rawUrl);
        origin = u.origin;
        hostname = u.hostname;
    } catch {
        origin = rawUrl;
        hostname = rawUrl;
    }

    const fromHost = hostnameBrand(hostname);
    if (fromHost !== undefined) {
        return fromHost;
    }

    for (const key of Object.keys(originToBrand)) {
        if (origin.startsWith(key)) {
            return originToBrand[key];
        }
    }

    return undefined;
}
